/* VisionPêche - bouton « retour en haut ».
   Apparaît après un écran et demi de défilement, disparaît en haut de page.

   Volontairement sans requestAnimationFrame : rAF est suspendu dans un onglet
   d'arrière-plan, ce qui rendait le bouton intestable et le laissait figé.
   Le calcul est de toute façon trivial et sort tout de suite si rien ne change. */
(function () {
  var bouton = document.getElementById('vp-haut');
  if (!bouton) return;

  var SEUIL = 700;
  var DUREE_FONDU = 200; // doit rester aligne sur la transition CSS
  var visible = false;
  var minuterie = null;

  function position() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function ajuster() {
    var doitEtreVisible = position() > SEUIL;
    if (doitEtreVisible === visible) return;
    visible = doitEtreVisible;

    if (minuterie) { clearTimeout(minuterie); minuterie = null; }

    if (visible) {
      bouton.hidden = false;
      void bouton.offsetHeight; // force le calcul de style avant la transition
      bouton.classList.add('vp-haut--visible');
    } else {
      bouton.classList.remove('vp-haut--visible');
      minuterie = setTimeout(function () {
        if (!visible) bouton.hidden = true;
      }, DUREE_FONDU);
    }
  }

  window.addEventListener('scroll', ajuster, { passive: true });
  window.addEventListener('resize', ajuster, { passive: true });
  ajuster();

  bouton.addEventListener('click', function () {
    var douxAutorise = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: douxAutorise ? 'smooth' : 'auto' });
    // Rendre le focus au debut du document, sinon la tabulation reprend en bas.
    var cible = document.getElementById('MainContent') || document.body;
    cible.setAttribute('tabindex', '-1');
    cible.focus({ preventScroll: true });
  });
})();
